module.exports = __webpack_public_path__ + "img/profile.25ec01a2.svg";